import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Download,
  File,
  Filter,
  PlusCircle,
  RotateCcw,
  Sliders,
  StopCircle,
  Archive,
  User,
  Calendar,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { Table, TimePicker } from "antd";
import { purchaseslist } from "../../../core/json/purchaselistdata";
import { setheadertoggle } from "../../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import {
  getSalesReport,
  getPaxReport,
} from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import {
  exportPDF,
  exportExcel,
  HandlePrint,
  renderTooltip,
} from "../../../redux/helper";
import * as XLSX from "xlsx";
import { Checkbox } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DatePicker } from "antd";
// import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import {
  fetchCounter,
  fetchSection,
  fetchUserRole,
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSettings,
  fetchCustomer,
} from "../../../redux/userSetting";
import { fetchUser, fetchUserByBranch } from "../../../redux/userServices";
import {
  exportreportExcel,
  exportreportPDF,
  printreportReport,
} from "../../../core/utils/MainReportUtils";
import LoadingUtils from "../../../core/utils/LoadingUtils";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

const PaxReport = () => {
  //const purchasedata = purchaseslist;
  const [searchText, setSearchText] = useState("");
  //const [salesData, setsalesData] = useState();
  const [waiter, setwaiter] = useState();
  const [zone, setZone] = useState();
  const [sectionval, setsectionval] = useState();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [totalcount, settotalcount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [allData, setallData] = useState();
  const [fromTime, setFromTime] = useState(null);
const [toTime, setToTime] = useState(null);

  const dispatch = useDispatch();
    const [decimalpoints, setDecimalPoints] = useState(2);
    const {
      productList,
      unitList,
      settingList,
      customerList,
      formatedproductList,
    } = useSelector((state) => state.usersetting);
  const { branch } = useSelector((state) => state.branchlist);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const { userRoles, counterList, sectionList } = useSelector(
    (state) => state.usersetting
  );
  const { UserListByBranch } = useSelector((state) => state.userservice);
  const tableRef = useRef(null);

  
  useEffect(() => {
    handlegetsalesReport(currentPage, pageSize);
    handlegetsalesfullReport();
   // dispatch(fetchUser(branch?.guid));
    dispatch(fetchSection(branch.guid));
    dispatch(fetchCounter(branch.guid));
     dispatch(fetchUnit());
        dispatch(fetchProduct(branch));
        dispatch(fetchTax());
        dispatch(fetchSettings(branch));
    
        const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
        const currfmt = match ? match[0]?.length - 1 : 0;
        setDecimalPoints(currfmt);
  }, [branch, toDate, fromDate]);


    useEffect(() => {
      dispatch(fetchUserByBranch(branch.guid));
    }, [branch]);

const handlegetsalesReport = async (page, size) => {
  const DatatablePagingParameters = new DatatablePagingParameter();
  DatatablePagingParameters.PageNumber = page;
  DatatablePagingParameters.PageSize = size;

  const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
  const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");

  const Filters = new Filterclass();
  Filters.Branch = branch;
  Filters.FromDate = formattedfromDate;
  Filters.ToDate = formattedtoDate;

  // Send correct filter values according to API response
  Filters.Holder = waiter?.label || null;       // user.name
  Filters.Zone = zone?.label || null;    // zoneName
  Filters.Section = sectionval?.label || null; // section.name

  try {
    const response = await getPaxReport({
      DatatablePagingParameters,
      Filters,
    });

    const data = response?.data?.salesReportDetail || [];
    settotalcount(data.length);
  } catch (error) {
    console.error("Error Fetching PAX Report!", error?.response?.data?.Message);
  }
};

const handlegetsalesfullReport = async () => {
  setloading(true);
  const DatatablePagingParameters = new DatatablePagingParameter();
  DatatablePagingParameters.PageNumber = 1;
  DatatablePagingParameters.PageSize = -1;

  const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
  const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");

  const Filters = new Filterclass();
  Filters.Branch = branch;
  Filters.FromDate = formattedfromDate;
  Filters.ToDate = formattedtoDate;

  Filters.Holder = waiter?.label || null;       // user.name
  Filters.Zone = zone?.label || null;    // zoneName
  Filters.Section = sectionval?.label || null; // section.name

  try {
    const response = await getPaxReport({
      DatatablePagingParameters,
      Filters,
    });

    const result = response?.data?.salesReportDetail || [];
    setallData(result);
    settotalcount(result.length);
  } catch (error) {
    console.error("Error Fetching Full PAX Report!", error?.response?.data?.Message);
  } finally {
    setloading(false);
  }
};


  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const handleReset = () => {
    // setFromDate((prev) => dayjs());
    // setToDate((prev) => dayjs());
     setFromDate(dayjs());
  setToDate(dayjs());
    setSearchText("");
    setwaiter("");
    setZone("");
    setsectionval("");
    // handlegetsalesfullReport();
    handlegetsalesReport(currentPage, pageSize);
  };


//   const handleReset = () => {
//   setFromDate(dayjs());
//   setToDate(dayjs());
//   setSearchText("");
//   setwaiter(null);
//   setcounterval(null);
//   setsectionval(null);

//   // Refresh data after reset
//   handlegetsalesfullReport();
//   handlegetsalesReport(1, pageSize);
// };


const menuItems = [
  { value: "1", label: "Date", checked: true },
  { value: "2", label: "Time", checked: true },
  { value: "3", label: "Bill No", checked: true },
  { value: "4", label: "Lounge Name", checked: true },
  { value: "5", label: " Zone", checked: true },
  { value: "6", label: "Table", checked: true },
  { value: "7", label: "Chair", checked: true },
  { value: "8", label: "Section", checked: true },
  { value: "9", label: "Holder", checked: true },
  { value: "10", label: "PAX Count", checked: true },

];

const columns = [
  {
    title: "Transaction Date",
    key: "1",
    dataIndex: "transactionDate",
    render: (text) => {
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      };
      return <span>{formatDate(text)}</span>;
    },
    sorter: (a, b) => new Date(a.transactionDate) - new Date(b.transactionDate),
  },
  {
    title: "Time",
    key: "2",
    dataIndex: "billDate",
    render: (text) => {
      const date = new Date(text);
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    sorter: (a, b) => new Date(a.billDate) - new Date(b.billDate),
  },
    {
    title: "Bill No",
    key: "3",
    dataIndex: "billNo",
    sorter: (a, b) => a.billNo - b.billNo,
  },
  {
    title: "PAX Count",
    key: "10",
    dataIndex: "pax",
    render: (text) => <span>{text || 0}</span>,
    sorter: (a, b) => a.paxCount - b.paxCount,
  },
  {
    title: "Lounge ",
    key: "4",
    dataIndex: "branch",
    render: (text) => <span>{text?.name || "-"}</span>,
  },
{
  title: "Zone",
  key: "5",
  dataIndex: "zoneName",
  render: (text) => <span>{text || "-"}</span>,
},
  {
    title: "Table",
    key: "6",
    dataIndex: "tableName",
    render: (text) => <span>{text || "-"}</span>,
  },
  {
    title: "Chair",
    key: "7",
    dataIndex: "chairNo",
    render: (text) => <span>{text || "-"}</span>,
  },
  {
    title: "Section",
    key: "8",
    dataIndex: "section",
    render: (text) => <span>{text?.name || "-"}</span>,
  },
  {
    title: "Holder",
    key: "9",
    dataIndex: "user",
    render: (text) => <span>{text?.name || "-"}</span>,
  },

];

  const [selectedColumns, setSelectedColumns] = useState();

  useEffect(() => {
    // Set default selected columns based on menuItems' checked status
    const initialSelectedColumns = menuItems
      ?.filter((item) => item.checked)
      ?.map((item) => columns?.find((col) => col.key === item.value));

    setSelectedColumns(initialSelectedColumns);
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      // Add column if checkbox is checked
      setSelectedColumns((prevColumns) => {
        const updatedColumns = [
          ...prevColumns,
          columns?.find((col) => col.key === columnKey),
        ];

        // Sort the array by col.key in ascending order
        return updatedColumns.sort((a, b) => (a.key > b.key ? 1 : -1));
      });
    } else {
      // Remove column if checkbox is unchecked
      setSelectedColumns((prevColumns) =>
        prevColumns?.filter((col) => col.key !== columnKey)
      );
    }
  };

 const userroles = UserListByBranch?.map((e) => ({
  value: e.guid,
  label: e.name,
}));

// Zones are strings from API's zoneName
const zoneOptions = Array.from(
  new Set(allData?.map((item) => item.zoneName))
)?.map((zone) => ({ value: zone, label: zone }));

// Sections are objects
const sectionOptions = sectionList?.map((e) => ({
  value: e.name,
  label: e.name,
}));

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleFromDateChange = (date) => {
    console.log(date, "from date");
    setFromDate(date);

    setToDate(null); // reset to date when from date changes
  };
  const handleToDateChange = (date) => {
    setToDate(date);
    console.log(date, "to date");
  };

  

const modifiedList = allData?.filter((obj) => {
  const searchMatch =
    !searchText ||
    obj.billNo?.toString()?.toLowerCase().includes(searchText.toLowerCase()) ||
    obj.zoneName?.toLowerCase().includes(searchText.toLowerCase()) ||
    obj.user?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
    obj.section?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
    obj.tableName?.toLowerCase().includes(searchText.toLowerCase());
    
// const billTime = dayjs(obj.billDate).format("HH:mm");
//   const timeMatch =
//   !fromTime ||
//   dayjs(obj.billTime, "HH:mm").isBetween(
//     dayjs(fromTime).format("HH:mm"),
//     dayjs(toTime).format("HH:mm"),
//     null,
//     "[]"
//   );

  const holderMatch = !waiter || obj?.user?.name === waiter?.label;
  const zoneMatch = !zone || obj?.zoneName === zone?.label;
  const sectionMatch = !sectionval || obj?.section?.name === sectionval?.label;


  return searchMatch && holderMatch && zoneMatch && sectionMatch ;
});

const modifiedallList = allData?.filter((obj) => {
  const searchLower = searchText?.toLowerCase();

  const searchMatch =
    !searchText ||
    obj.billNo?.toString()?.toLowerCase().includes(searchLower) ||
    obj.zoneName?.toLowerCase().includes(searchLower) ||
    obj.user?.name?.toLowerCase().includes(searchLower) ||
    obj.section?.name?.toLowerCase().includes(searchLower) ||
    obj.tableName?.toLowerCase().includes(searchLower);

  const holderMatch = !waiter || obj?.user?.name === waiter?.label;
  const zoneMatch = !zone || obj?.zoneName === zone?.label;
  const sectionMatch = !sectionval || obj?.section?.name === sectionval?.label;

  return searchMatch && holderMatch && zoneMatch && sectionMatch;
});


  
  const getActiveTabData = () => {
    let fieldMapping = {};

    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        mappings[col.title] = col.dataIndex; // Map title to dataIndex
      });
      return mappings;
    };

    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);


    // Return the filtered data, columns, and field mapping
    return { data: modifiedallList, columns: selectedColumns, fieldMapping,Rname:"PAX Count Report" };
  };

const totalChair = modifiedallList?.reduce(
  (sum, record) => sum + Number(record.chairNo || 0),
  0
);
const totalpax = modifiedallList?.reduce(
  (sum, record) => sum + Number(record.pax || 0),
  0
);

const footerTotals = {
  pax: totalpax,
  // chairNo: totalChair,
};


  const handleRefresh = () => {
    handlegetsalesReport(currentPage, pageSize);
   handlegetsalesfullReport(); 
 };
  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>PAX Count Report</h4>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() =>
                      exportreportPDF(
                        getActiveTabData,
                        footerTotals,companyInfolist
                      )
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <button
                    onClick={() =>
                      exportreportExcel(
                        getActiveTabData,
                        footerTotals,companyInfolist
                      )
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel-icon"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <button
                    onClick={() =>
                      printreportReport(
                        getActiveTabData,
                        footerTotals,companyInfolist
                      )
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                                                          <OverlayTrigger
                                                            placement="top"
                                                            overlay={() => renderTooltip("Refresh")}
                                                          >
                                                            <Link onClick={handleRefresh}>
                                                              <RotateCcw/>
                                                            </Link>
                                                          </OverlayTrigger>
                                                        </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set mt-2">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg> */}
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-blocks">
                      <label htmlFor="from-date">From Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          placeholderText="From Date"
                          // selected={fromDate}
                          value={fromDate}
                          onChange={handleFromDateChange}
                          startDate={fromDate}
                          selectsStart
                          // dateFormat="dd/MM/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-blocks mr-2">
                      <label htmlFor="to-date">To Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          id="to-date"
                          placeholderText="To Date"
                          // selected={toDate}
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          startDate={fromDate}
                          selectsEnd
                          disabled={!fromDate} // disable until from date is selected
                          // dateFormat="dd/MM/yyyy"
                          // className='form-control'
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <div className="input-blocks me-2">
                    <Link
                      className="btn btn-filters ms-auto"
                      onClick={() => {
                        setCurrentPage(1);
                        setPageSize(20);
                        handlegetsalesfullReport();
                        handlegetsalesReport(currentPage, pageSize);
                      }}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      search{" "}
                    </Link>
                  </div>
                  <div className="input-blocks">
                    <button
                      className="btn btn-reset rounded-2"
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    onClick={toggleFilterVisibility}
                    id="filter_search"
                  >
                    <Filter className="filter-icon" />
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>

                <div className="dropdown">
                  <button
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Sliders className="info-img" />
                  </button>
                  <ul className="dropdown-menu p-2">
                    {menuItems?.map((obj, i) => {
                      return (
                        <li key={i}>
                          <Checkbox
                            onChange={(e) =>
                              handleCheckboxChange(obj.value, e.target.checked)
                            }
                            defaultChecked={obj.checked}
                          >
                            <div style={{ color: "black" }}> {obj.label}</div>
                          </Checkbox>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                 <div className="row">
                  {/* <div className="col-12 col-md-4 col-xl-2">
  <div className="input-blocks">
    <label>From Time</label>
    <TimePicker
      format="HH:mm"
      value={fromTime}
  onChange={setFromTime}
      className="w-100"
    />
  </div>
</div>

<div className="col-12 col-md-4 col-xl-2">
  <div className="input-blocks">
    <label>To Time</label>
    <TimePicker
      format="HH:mm"
      value={toTime}
  onChange={setToTime} 
      disabled={!fromTime}
      className="w-100"
    />
  </div>
</div> */}
  <div className="col-lg-3 col-sm-6 col-12">
    <div className="input-blocks">
      <User className="info-img" />
      <Select
        className="img-select"
        options={userroles}
        value={waiter}
        onChange={setwaiter}
        isClearable
        classNamePrefix="react-select"
        placeholder="Select Holder"
      />
    </div>
  </div>

  <div className="col-lg-3 col-sm-6 col-12">
    <div className="input-blocks">
      <Archive className="info-img" />
      <Select
        className="img-select"
       options={zoneOptions}
        value={zone}
        isClearable
        onChange={setZone}
        classNamePrefix="react-select"
        placeholder="Select Zone"
      />
    </div>
  </div>

  <div className="col-lg-3 col-sm-6 col-12">
    <div className="input-blocks">
      <File className="info-img" />
      <Select
        className="img-select"
         options={sectionOptions}
        value={sectionval}
        isClearable
        onChange={setsectionval}
        classNamePrefix="react-select"
        placeholder="Select Section"
      />
    </div>
  </div>
</div>

                </div>
              </div>
              {/* /Filter */}
              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    columns={selectedColumns}
                    dataSource={modifiedList}
                    ref={tableRef}
                    id="table-to-export"
                    className="table datanew dataTable no-footer custom-table"
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalcount, // Total records count
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        handlegetsalesReport(page, size);
                      },
                      showSizeChanger: true, // To enable page size selection dropdown
                      pageSizeOptions: ["10", "20", "50", "100"], // Different page size options
                    }}
          
                    // summary={() => (
                    //   <Table.Summary.Row>
                    //     {selectedColumns?.map((col) => (
                    //       <Table.Summary.Cell key={col.dataIndex}>
                    //         <b>{footerTotals[col.dataIndex] || ""}</b>
                    //       </Table.Summary.Cell>
                    //     ))}
                    //   </Table.Summary.Row>
                    // )}
                      summary={() => (
    <Table.Summary.Row>
      {selectedColumns?.map((col) => (
        <Table.Summary.Cell key={col.dataIndex}>
          <b>
            {footerTotals[col.dataIndex] || ""}
          </b>
        </Table.Summary.Cell>
      ))}
    </Table.Summary.Row>
  )}

                  />
                </div>
              )}
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};
export default PaxReport;
